import { useNavigate } from 'react-router-dom';
import {
  Users2,
  MapPin,
  Bell,
  Database,
  Shield,
  FileText,
  type LucideIcon,
} from 'lucide-react';

interface QuickAction {
  label: string;
  description: string;
  icon: LucideIcon;
  path: string;
  color: string;
}

const actions: QuickAction[] = [
  {
    label: 'View Users',
    description: 'Manage user accounts',
    icon: Users2,
    path: '/users',
    color: 'bg-blue-500/10 text-blue-400 hover:bg-blue-500/20',
  },
  {
    label: 'Moderation Queue',
    description: 'Review flagged content',
    icon: Shield,
    path: '/moderation/queue',
    color: 'bg-red-500/10 text-red-400 hover:bg-red-500/20',
  },
  {
    label: 'ZIP Master',
    description: 'Seed reference data',
    icon: MapPin,
    path: '/reference/zip-master',
    color: 'bg-green-500/10 text-green-400 hover:bg-green-500/20',
  },
  {
    label: 'System Health',
    description: 'Check API status',
    icon: Database,
    path: '/system/health',
    color: 'bg-purple-500/10 text-purple-400 hover:bg-purple-500/20',
  },
  {
    label: 'Push Notifications',
    description: 'Send announcements',
    icon: Bell,
    path: '/system/push',
    color: 'bg-yellow-500/10 text-yellow-400 hover:bg-yellow-500/20',
  },
  {
    label: 'View Logs',
    description: 'System logs',
    icon: FileText,
    path: '/system/logs',
    color: 'bg-slate-500/10 text-slate-400 hover:bg-slate-500/20',
  },
];

export function QuickActions() {
  const navigate = useNavigate();

  return (
    <div className="bg-slate-900/50 border border-slate-800 rounded-xl p-5">
      <h3 className="text-lg font-semibold text-white mb-4">Quick Actions</h3>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
        {actions.map((action) => (
          <button
            key={action.path}
            onClick={() => navigate(action.path)}
            className={`flex flex-col items-center p-4 rounded-lg transition-colors ${action.color}`}
          >
            <action.icon className="h-6 w-6 mb-2" />
            <span className="text-sm font-medium text-white">{action.label}</span>
            <span className="text-xs text-slate-400 mt-1 text-center">
              {action.description}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}
